import { render, staticRenderFns } from "./TipoEventos.vue?vue&type=template&id=63c02f04&scoped=true&"
import script from "./TipoEventos.vue?vue&type=script&lang=js&"
export * from "./TipoEventos.vue?vue&type=script&lang=js&"
import style0 from "./TipoEventos.vue?vue&type=style&index=0&id=63c02f04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c02f04",
  null
  
)

export default component.exports